import {
  createPatientEvent,
  getPatientEventByCharge,
  getPatientEventByPatientId,
  updatePatientEvent,
  updatePatientFacilityEvent,
} from './backendHelper'

export async function getPatientEventHistory(patientId) {
  if (!patientId) {
    return []
  }
  try {
    let res = await getPatientEventByPatientId(patientId)
    return Array.isArray(res) ? res : []
  } catch (e) {
    console.error(e)
    return []
  }
}

export async function getPatientEventWithCharge(chargeId) {
  if (!chargeId) {
    return null
  }
  try {
    return await getPatientEventByCharge(chargeId)
  } catch (e) {
    console.error(e)
    return null
  }
}

export async function createNewPatientEvent(payload) {
  try {
    let createdId = await createPatientEvent(payload)
    return Boolean(createdId)
  } catch (e) {
    console.error(e)
    return false
  }
}

export async function overridePatientEvent(payload) {
  try {
    let createdId = await updatePatientEvent(payload)
    return Boolean(createdId)
  } catch (e) {
    console.error(e)
    return false
  }
}

export async function updatePatientEventFacilityDetails(payload) {
  try {
    let createdId = await updatePatientFacilityEvent({ ...payload, type: 'FACILITY' })
    return Boolean(createdId)
  } catch (e) {
    console.error(e)
    return false
  }
}
